export default __webpack_public_path__ + "static/media/041-humps.79e1aee3.png";